import React from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { X, Plane } from 'lucide-react';
import useFocusTrap from '../../hooks/useFocusTrap';

function RatesModal({ open, onClose, onBook }) {
  const { t } = useTranslation();
  const ref = useFocusTrap(open, onClose);
  const routes = t('rates.routes', { returnObjects: true });

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-overlay flex items-end justify-center p-0 font-sans sm:items-center sm:p-6">
      <div className="absolute inset-0 bg-navy-deep/75" aria-hidden="true" onClick={onClose} />
      <div
        ref={ref}
        role="dialog"
        aria-modal="true"
        aria-labelledby="rates-title"
        tabIndex={-1}
        className="relative w-full max-w-md rounded-t-card bg-white p-6 shadow-card focus:outline-none sm:rounded-card sm:p-8"
      >
        <div className="flex items-start justify-between gap-4">
          <h2 id="rates-title" className="m-0 text-2xl font-bold tracking-tight text-navy">
            {t('site.rates.title')}
          </h2>
          <button
            type="button"
            onClick={onClose}
            aria-label={t('site.rates.close')}
            className="focus-ring-light -mr-2 -mt-1 inline-flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-btn border-0 bg-transparent text-navy hover:bg-mist"
          >
            <X size={22} aria-hidden="true" />
          </button>
        </div>
        <ul className="m-0 mt-6 list-none divide-y divide-slate-200 p-0">
          {routes.map((route) => (
            <li key={route.route} className="flex items-center justify-between gap-4 py-4">
              <span className="flex items-center gap-3 font-semibold text-navy">
                <Plane size={18} aria-hidden="true" className="shrink-0 text-slate-500" />
                {route.route}
              </span>
              <span className="text-xl font-extrabold text-navy">{route.price}</span>
            </li>
          ))}
        </ul>
        <p className="mb-0 mt-4 text-sm leading-relaxed text-slate-600">{t('rates.note')}</p>
        <Link
          to="/rates"
          onClick={onClose}
          className="focus-ring-light mt-3 inline-block rounded font-semibold text-navy underline decoration-navy/30 underline-offset-4 hover:decoration-navy"
        >
          {t('site.rates.fullList')}
        </Link>
        <button type="button" className="btn-primary focus-ring-light mt-6 w-full" onClick={onBook}>
          {t('site.nav.bookNow')}
        </button>
      </div>
    </div>,
    document.body
  );
}

export default RatesModal;
